import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6d1d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full align-items-center" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "text-sm pi pi-chevron-down ml-s2 w-1rem" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "flex mt-s3 align-items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "mt-s2"
}
const _hoisted_6 = { class: "text-right pt-s3" }
const _hoisted_7 = { class: "select-token-list scrollable" }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useTokens } from '@/store/modules/tokens/useTokens';
import { useI18n } from 'vue-i18n';

import TokenPanel from './TokenPanel.vue';
import Switch from '@/components/switch/Switch.vue';
import { Token } from '@/sdk/entities/token';
import { Fields } from '@/store/modules/swap/swap.module';
import TokenIcon from '@/components/token/TokenIcon.vue';
import SearchInput from '@/components/form/SearchInput.vue';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import { DEFAULT_NETWORK_ID } from '@/helpers/networkParams.helper';
import CrossChainNetworkListDropdown from '@/components/CrossChainNetworkListDropdown.vue';
import { ENABLE_CROSS_CHAIN } from '@/helpers/crossChainEnv.helper';
import { ChainId } from '@/sdk/constants';
import { BASE_TOKENS } from '@/constants/baseTokens';
import { useEVMWallet } from '@/store/modules/wallet/useEVMWallet';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenSelect',
  props: {
    token: null,
    fieldType: null,
    hideZeroBalances: { type: Boolean },
    showFilterZeroBalances: { type: Boolean },
    chainSelectDisable: { type: Boolean }
  },
  emits: ["onChangeSelect"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onChangeSelect', value: Token): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  token: Token | null;
  fieldType: Fields;
  hideZeroBalances?: boolean;
  showFilterZeroBalances?: boolean;
  chainSelectDisable?: boolean;
}




const { getTokensListByChainIdWithFilter, filterByPresentLocally } = useTokens();
const { t } = useI18n();
const { state } = useStore();
const { walletState } = useEVMWallet();

const hideZeros = ref(props.hideZeroBalances ?? false);
const isShowDialog = ref(false);
const tokenFilter = ref('');
const selectedDestinationChain = ref<ChainId>(
  ENABLE_CROSS_CHAIN && walletState.network
    ? walletState.network.chainId
    : toChainId(DEFAULT_NETWORK_ID),
);
const selectedNetwork = computed(() => walletState.network?.chainId ?? DEFAULT_NETWORK_ID);
const baseToken = computed(() => BASE_TOKENS[selectedDestinationChain.value]);

const onShowDialog = () => {
  selectedDestinationChain.value = props.token
    ? props.token.chainId
    : toChainId(selectedNetwork.value);
  isShowDialog.value = true;
};
const onHideDialog = () => {
  isShowDialog.value = false;
};
const onSelectToken = token => {
  if (!token) return;
  emits('onChangeSelect', token);
  onHideDialog();
};
const tokenList = computed(() => {
  const tokenIntoDestinationChain = getTokensListByChainIdWithFilter(
    selectedDestinationChain.value,
    null,
    tokenFilter.value,
  );
  return filterByPresentLocally(tokenIntoDestinationChain);
});
const onCloseTokenSelect = () => {
  tokenFilter.value = '';
};
const onChangeDestinationChain = event => {
  console.log(`Destination chain: ${event.value}`, baseToken.value);
  selectedDestinationChain.value = toChainId(event.value);
};

onMounted(() => onSelectToken(props.token));

function toChainId(value: any): ChainId {
  return +(value ?? -1);
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: _normalizeClass(["flex-shrink-0 button-base", { 'pl-s2': __props.token }]),
      onClick: onShowDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (__props.token)
            ? (_openBlock(), _createBlock(TokenIcon, {
                key: 0,
                "icon-src": __props.token.tokenIconUrl,
                symbol: __props.token.symbol,
                full: "",
                "txt-only": _unref(state).layout.isMobile,
                "chain-id": _unref(ENABLE_CROSS_CHAIN) ? __props.token.chainId : undefined,
                size: "20"
              }, null, 8, ["icon-src", "symbol", "txt-only", "chain-id"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('token')), 1)),
          _hoisted_3
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_Dialog, {
      visible: isShowDialog.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((isShowDialog).value = $event)),
      header: _unref(t)('swap.tokenSelectDialog.title'),
      modal: true,
      dismissableMask: "",
      class: "w-full dialog-setting dialog-list md:w-25rem",
      onHide: onCloseTokenSelect
    }, {
      default: _withCtx(() => [
        _createVNode(SearchInput, {
          modelValue: tokenFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tokenFilter).value = $event)),
          placeholder: _unref(t)('swap.tokenSelectDialog.searchPlaceholder'),
          class: "w-full mt-s2"
        }, null, 8, ["modelValue", "placeholder"]),
        (_unref(ENABLE_CROSS_CHAIN))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('swap.tokenSelectDialog.networkSelect.caption')), 1),
              _createVNode(TooltipIcon, {
                tooltip: _unref(t)(`swap.tokenSelectDialog.networkSelect.tooltip.${__props.fieldType}`)
              }, null, 8, ["tooltip"])
            ]))
          : _createCommentVNode("", true),
        (_unref(ENABLE_CROSS_CHAIN))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(CrossChainNetworkListDropdown, {
                "default-chain-id": selectedDestinationChain.value,
                "is-readonly": __props.chainSelectDisable,
                onOnChange: _cache[1] || (_cache[1] = ($event: any) => (onChangeDestinationChain($event)))
              }, null, 8, ["default-chain-id", "is-readonly"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (__props.showFilterZeroBalances && _unref(walletState).isInjected)
            ? (_openBlock(), _createBlock(Switch, {
                key: 0,
                name: _unref(t)('swap.tokenSelectDialog.hideZeroBalances'),
                modelValue: hideZeros.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hideZeros).value = $event))
              }, null, 8, ["name", "modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Divider),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokenList), (token) => {
            return (_openBlock(), _createBlock(TokenPanel, {
              token: token,
              "is-base-token": token.symbol === _unref(baseToken).symbol,
              key: token.symbol,
              "hide-zero-balance": hideZeros.value,
              onClick: ($event: any) => (onSelectToken(token)),
              class: "mt-s1"
            }, null, 8, ["token", "is-base-token", "hide-zero-balance", "onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})